"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyCipher = copyCipher;
exports.deleteCipher = deleteCipher;
exports.getCipherDetail = getCipherDetail;
exports.getCipherJoinPage = getCipherJoinPage;
exports.getCipherList = getCipherList;
exports.getCipherStock = getCipherStock;
exports.resendCipherJoin = resendCipherJoin;
exports.saveCipher = saveCipher;
exports.toggleCipherStatus = toggleCipherStatus;
exports.uploadCipherImage = uploadCipherImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 获取口令活动列表
 * @param {Object} query - 查询参数
 */
function getCipherList(query) {
  return (0, _requestAuth.default)({
    url: '/cipherActivity/list',
    method: 'get',
    params: query
  });
}

/**
 * 获取口令活动详情
 * @param {Number} id - 活动ID
 */
function getCipherDetail(id) {
  return (0, _requestAuth.default)({
    url: "/cipherActivity/".concat(id),
    method: 'get'
  });
}

/**
 * 保存口令活动（新增或更新）
 * @param {Object} data - 活动数据
 */
function saveCipher(data) {
  return (0, _requestAuth.default)({
    url: '/cipherActivity',
    method: 'post',
    data: data
  });
}

/**
 * 库存统计（猜对/猜错的总库存与剩余库存）
 * @param {Number} id - 活动ID
 */
function getCipherStock(id) {
  return (0, _requestAuth.default)({
    url: "/cipherActivity/stock/".concat(id),
    method: 'get'
  });
}

/**
 * 删除口令活动
 * @param {Number} id - 活动ID
 */
function deleteCipher(id) {
  return (0, _requestAuth.default)({
    url: "/cipherActivity/".concat(id),
    method: 'delete'
  });
}

/**
 * 启用/禁用口令活动
 * @param {Number} id - 活动ID
 * @param {Number} isEnable - 状态值
 */
function toggleCipherStatus(id, isEnable) {
  return (0, _requestAuth.default)({
    url: "/cipherActivity/toggleStatus/".concat(id),
    method: 'post',
    data: {
      isEnable: isEnable
    }
  });
}

/**
 * 复制口令活动（主表 + 奖励明细，不复制兑换码，新活动默认禁用）
 * @param {Number} id - 活动ID
 */
function copyCipher(id) {
  return (0, _requestAuth.default)({
    url: "/cipherActivity/copy/".concat(id),
    method: 'post'
  });
}

/**
 * 上传口令活动图片
 * @param {File} file - 图片文件
 */
function uploadCipherImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/cipherActivity/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// ===================== 参与明细 =====================

/**
 * 获取参与明细分页列表
 * @param {Object} query - 搜索参数 { cipherId, type, statusGroup, userId }
 */
function getCipherJoinPage(query) {
  return (0, _requestAuth.default)({
    url: '/cipherActivity/join/page',
    method: 'get',
    params: query
  });
}

/**
 * 补发口令奖励（仅发券失败的参与记录：4-猜对发券失败，6-猜错发券失败）
 * @param {Number} id - 参与记录ID(xy_cipher_join.id)
 */
function resendCipherJoin(id) {
  return (0, _requestAuth.default)({
    url: "/cipherActivity/join/resend/".concat(id),
    method: 'post'
  });
}